import React from "react";
import { TimeStamp } from "../../../arrow/components/Atoms/TimeStamp";
import { HeroImage } from "../../../arrow/components/Atoms/HeroImage";
import { object, array, bool } from "prop-types";
import { Link } from "@quintype/components";
import "./image-type-3.m.css";
import slugRewrites from "../slug-rewrites";

const ImageType3 = ({ story, showSection = false, widths = [250, 375], behindPaywall, contentType, aspectRatio, showDateSection = true, isSearchPage = false }) => {
  const storyObj = story.story ? story.story : story;
  const accessType = storyObj?.access ?? null;
  const paywallIcons = accessType === "login" || accessType === "subscription";
  const imgS3keys = storyObj["hero-image-s3-key"];
  const storyAttributes = storyObj?.metadata?.["story-attributes"]?.storytype?.[0] ?? "";

  let finalSlug;
  if (isSearchPage) {
    finalSlug = slugRewrites[storyObj.slug] || storyObj.slug;
  } else {
    finalSlug = storyObj.slug;
  }

  return (
    <div styleName="wrapper" className="type-2">
      <Link href={`/${finalSlug}`}>
        <div styleName="type-2" className="type-2-card">
          {showSection && <h1>{storyObj.sections[0].name}</h1>}
          {imgS3keys !== null && (
            <div>
              <HeroImage story={storyObj}  aspectRatio={aspectRatio} isSearchPage={isSearchPage} customSlug={finalSlug}/>
              { contentType && (
              <div styleName="icon-style">
                {contentType === "Audio" && <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon"/>}
                {contentType === "Video" && <img alt="video-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon"/>}
              </div>
            )}
            </div>
          )}
        </div>
      </Link>
      <div className="main-headline" styleName={imgS3keys?"main-headline":"no-img"}>
        <div styleName="wrapper-inside" className="wrapper-inside">
          <Link href={`/${finalSlug}`}>
            <h2 styleName="headline-link">{storyObj.headline}</h2>
            <h2 styleName="sub-headline-link">{storyObj.subheadline}</h2>
          </Link>

          {showDateSection && (
            <div styleName="section-time-wrapper">
              <TimeStamp story={storyObj} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ImageType3.propTypes = {
  story: object,
  widths: array,
  showSection: bool,
};

export default React.memo(ImageType3);
